import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded tw-text-sm tw-font-semibold tw-ring-offset-white tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-border-none disabled:tw-bg-primary-100 disabled:tw-text-black-100  ",
  {
    variants: {
      variant: {
        default: "tw-bg-primary tw-text-white tw-shadow hover:tw-bg-primary/95",
        secondary:
          "tw-border tw-border-primary-300 tw-bg-primary-300 tw-text-white",
        "secondary-outlined":
          "tw-border tw-border-primary-400 tw-bg-white tw-text-primary-400 hover:tw-border-primary-300 hover:tw-bg-primary-300 hover:tw-text-white",
        success: "tw-bg-mint-500 tw-text-white hover:tw-bg-mint-500/90",
        ghost: "",
        link: "tw-text-primary tw-underline-offset-4 hover:tw-underline",
        outline:
          "tw-border tw-border-primary tw-text-primary hover:tw-bg-primary hover:tw-text-white",
        danger: "tw-bg-red-500 tw-text-white hover:tw-bg-red-700",
      },
      size: {
        default: "tw-h-9 tw-px-4 tw-py-2",
        sm: "tw-h-8 tw-px-3 tw-text-xs",
        lg: "tw-px-8 tw-py-3 tw-text-lg tw-font-bold",
        icon: "tw-h-9 tw-w-9",
        plain: "",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
